import React from "react"
import PropTypes from "prop-types"
import {AnalysisContext, CommentsContext} from "@irati/insights/context"

const AnalysisCommentsConsumer = ({children}) => {
  return (
    <AnalysisContext.Consumer>
      {(analysis) => (
        <CommentsContext.Consumer>
          {(comments) => children({...analysis, ...comments})}
        </CommentsContext.Consumer>
      )}
    </AnalysisContext.Consumer>
  )
}

AnalysisCommentsConsumer.propTypes = {
  children: PropTypes.func.isRequired
}

export default AnalysisCommentsConsumer
